import React from 'react'
import { Flex } from '@components'
import { Form, Button, Modal } from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import { message } from 'antd/lib/index'
import NHFetch from '../../../../utils/NHFetch'
import NHSelect from '@components/common/NHSelect'
import NHUpload from '@components/common/NHUpload'
import NHSignDraw from '@components/common/NHSignDraw'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { getLoginUser } from '@utils/NHCore'
import CommonTip from '../common'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'
import { Scrollbars } from 'react-custom-scrollbars'
import html2canvas from 'html2canvas'
import css from './index.css'

const FormItem = Form.Item
const basicUrl = 'api/zhxg-yxwz'
const { confirm } = Modal

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 10 }
}

@Form.create()
export default class Accommodation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      xsid: getLoginUser().userId,
      zzbdhjid: this.getUrlParams('pkid'),
      mkbz: 'GD046',
      hjmc: '阅读交通承诺书',
      editable: false,
      nextUrl: '', //左侧菜单加载完后传进来
      search: '',
      operable: true, //是否显示环节
      nonOperationalData: {}, //不可操作的数据
      modalVisible: false,
      signature: '', //签名对话框
      undertakingHtml: '', //承诺书富文本
      xssfytj: '', //学生是否已提交
      formData: {}, //学生已提交的入住信息
      isRender: false, //是否渲染
    }
  }

  //渲染前获取信息
  componentDidMount() {
    this.queryQztjAndYlhj()
    this.getRzsxPz()
  }

  //查询前置条件和依赖环节
  queryQztjAndYlhj = () => {
    const { zzbdhjid } = this.state
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid) {
      this.setState({
        nonOperationalData: { nologin: true },
        operable: false
      })
      return
    }
    NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid }).then(res => {
      if (res && res.data) {
        let kfsj = res.data['kfsj']
        let ylhj = res.data['ylhj']
        let qzhj = res.data['qzhj']
        let nohj = res.data['nohj']
        this.setState({ nonOperationalData: res.data })
        if (kfsj && kfsj['YXSJ'] != '1') {
          this.setState({ operable: false })
        }

        if (ylhj && ylhj.length > 0) {
          this.setState({ operable: false })
        }

        if (qzhj && qzhj.length > 0) {
          this.setState({ operable: false })
        }
        if (nohj) {
          this.setState({ operable: false })
        }
      }
    })
  }

  getQueryString = name => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  setMenuList = menuList => {
    let nextCount = 0
    let bz = this.state.mkbz
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC
        this.setState({ hjmc: hjmc })
        nextCount = index + 1
        return
      }
    })
    let menu = menuList[nextCount]
    if (menu) {
      let hjdm = menu.HJDM
      if (hjdm.indexOf('GD') == 0) {
        let gdUrl = mkbz[hjdm]
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID
        })
      } else if (hjdm.indexOf('ZDY') == 0) {
        let zdyUrl = '/customLink'
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
        })
      }
    } else {
      this.setState({
        nextUrl: '',
        search: ''
      })
    }
  }

  getUrlParams = param => {
    return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  //重新加载菜单
  reloadMenu = () => {
    this.refs.siderMenu.reloadMenuList()
  }

  // 选择是否认真阅读后处理
  handleSfydSelect = value => {
    const { editable } = this.state
    if (!editable) {
      return
    }
    if (value === '1') {
      this.setState({ modalVisible: true, signature: '' })
    } else if (value === '0') {
      message.warning('请先认真阅读交通承诺书')
      this.setState({ modalVisible: false })
    }
  }

  //保存
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }

      const { sfyd } = values
      if (sfyd === '0') {
        message.warning('请先认真阅读交通承诺书')
        return
      }

      // 无论是否申请入住，都需要签署承诺书
      this.setState({ modalVisible: true, signature: '' })
    })
  }

  // 提交承诺书
  submitUndertaking = () => {
    const { signature } = this.state
    const { getFieldValue } = this.props.form

    if (signature) {
      confirm({
        title: '确定提交?',
        onOk: () => {
          html2canvas(document.getElementById('signature'), { allowTaint: true, useCORS: true, scale: 1 }).then(canvas => {
            canvas.toBlob(blob => {
              this.saveXsRzsx({
                sfyd: getFieldValue('sfyd'),
                qm: blob
              })
            })
          })
        }
      })
    } else {
      message.warning('请签名')
    }
  }

  // 获取入住须知
  getRzsxPz = () => {
    const { xsid } = this.state
    NHFetch(`${basicUrl}/zzbd/ydjtcns/getYdjtcnsPz?xsid=${xsid}`, 'GET').then(res => {
      if (res && res.code === 200) {
        let nr = res.data?.nr ?? '';
        let xssfytj = res.data?.xssfytj ?? '0';
        this.setState({
          undertakingHtml: nr,
          xssfytj: xssfytj,
          editable: xssfytj === '0',
        })

        if (xssfytj === '1') {
          // 已提交
          this.getXxRzsx()
        } else {
          this.setState({ isRender: true })
        }
      }
    })
  }

  // 保存学生入住信息
  saveXsRzsx = params => {
    const { xsid, zzbdhjid } = this.state
    const formData = new FormData()
    const token = window.sessionStorage.getItem('access_token')

    // params.xsid = xsid
    params.zzbdhjid = zzbdhjid
    params.czpt = '1' //操作平台：PC端

    for (let key in params) {
      formData.append(key, params[key])
    }

    fetch(`${basicUrl}/zzbd/ydjtcns/saveXsYdjtcns`, {
      method: 'POST',
      headers: { token: token, loginUserId: xsid },
      body: formData
    })
      .then(async response => {
        const res = await response.json()
        if (res && res.code === 200) {
          if (res.data == '1') {
            message.success('信息保存成功！')
            this.getRzsxPz()
            this.reloadMenu()
            this.setState({ editable: false, modalVisible: false })
          } else {
            message.error('信息保存失败，请重试！')
          }
        }
      })
      .catch(err => {
        message.error('信息保存失败，请重试！')
      })
  }

  // 获取学生入住信息
  getXxRzsx = () => {
    const { xsid } = this.state
    NHFetch(`${basicUrl}/zzbd/ydjtcns/getXsYdjtcns/${xsid}`, 'GET').then(res => {
      if (res && res.code === 200) {
        this.setState({ formData: res.data || {} }, () => {
          this.setState({ isRender: true })
        })
      }
    })
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { editable, modalVisible, signature, undertakingHtml, formData, isRender } = this.state
    const date = new Date()

    return (
      <div>
        {this.state.operable ? (
          <Flex className="w1180 mt-20" align="start">
            <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到" mkbz={this.state.mkbz} menuType="自助报到" />
            <Flex.Item className="page_con_r">
              <Breadcrumb noLine list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]} />
              <div className="box">
                <Hint />
                <TitleTop title={this.state.hjmc} extra={false} />
                {isRender && (
                  <Form onSubmit={this.handleSubmit}>
                    <div className="p-sw">
                      <FormItem {...formItemLayout} label="是否认真阅读交通承诺书">
                        {editable &&
                          getFieldDecorator('sfyd', {
                            initialValue: formData.sfyd,
                            rules: [
                              {
                                required: true,
                                message: '请选择是否认真阅读交通承诺书'
                              }
                            ],
                          })(<NHSelect
                            dataSource={[{
                              value: '1',
                              label: '是'
                            }, {
                              value: '0',
                              label: '否'
                            }]}
                            onSelect={this.handleSfydSelect}
                          />)}

                        {!editable && (formData.sfyd === '1' ? '是' : '否')}
                      </FormItem>

                      <div className="text-center mt-50">
                        {editable && (
                          <Button type="primary" htmlType="submit">
                            保存
                          </Button>
                        )}

                        {!editable && (
                          <Button type="primary" onClick={() => this.setState({ editable: true })}>
                            修改
                          </Button>
                        )}

                        <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                      </div>
                    </div>
                  </Form>
                )}
              </div>
            </Flex.Item>
          </Flex>
        ) : (
          <CommonTip hjmc={'阅读交通承诺书'} key={'GD046'} mkbz="GD046" nonOperationalData={this.state.nonOperationalData} />
        )}

        {/* 用于生成承诺书 */}
        <div style={{width:'0px',height:'0px',position:'relative'}}>
          <div id="signature" className={css.signature} style={{ position: 'absolute', top: 0, left: 0, zIndex: -1, width: 800, padding: '72px 68px' }}>
            <article dangerouslySetInnerHTML={{ __html: undertakingHtml }} />
            <div style={{ paddingLeft: 450 }}>
              <div>
                承诺人：
                <img src={signature} alt="签名" style={{ width: 150 }} />
              </div>
              <div>
                {date.getFullYear()} 年 {date.getMonth() + 1} 月 {date.getDate()} 日
              </div>
            </div>
          </div>
        </div>


        <Modal title="请阅读交通承诺书后签名" visible={modalVisible} destroyOnClose width="max-content" okText="提交" onOk={this.submitUndertaking} onCancel={() => this.setState({ modalVisible: false })}>
          <Scrollbars style={{ height: 380, width: 800 }}>
            <div className={css.signature} style={{ width: 800, padding: '72px 68px'}}>
              <article dangerouslySetInnerHTML={{ __html: undertakingHtml }} />
              <NHSignDraw label={'签名'} onChange={value => this.setState({ signature: value?.signImg || '' })} />
            </div>
          </Scrollbars>
        </Modal>
      </div>
    )
  }
}